import { ArrowRight, AssignmentOutlined, Circle, CircleOutlined } from "@mui/icons-material";
import { IconButton, Link, TableCell, TableRow, Tooltip, Typography } from "@mui/material";
import { ITableColumn } from "App/Typings/Table";
import { IAbacClientTableRowProps } from "../State/AbacClientState";
import { Link as RouterLink } from "react-router-dom";

const classes = {
  rowCell: {
    cursor: "pointer !important",
    backgroundColor: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
    textAlign: "right",
  },
  tableCell: {
    color: "primary.copy",
  },
};

interface IAbacClientTableCellProps {
  element: IAbacClientTableRowProps;
  columns: ITableColumn[];
  customProps: any;
}

export default function AbacClientTableCell({ element, columns, customProps }: IAbacClientTableCellProps) {
  function displayDistribution() {
    const Icon =
      element.distribution === "Custom" ? (
        <Circle sx={{ color: "primary.main" }} fontSize="small" />
      ) : (
        <CircleOutlined sx={{ color: "NAS.lightBlue" }} fontSize="small" />
      );
    const tooltipText =
      element.distribution === "Custom" ? "Custom Distribution Overridden" : "Default Distribution";
    return (
      <Tooltip title={tooltipText} placement="right" arrow>
        <Typography sx={{ display: "inline-flex", alignItems: "center", lineHeight: 1 }} gap={1}>
          {Icon}
          {element.distribution}
        </Typography>
      </Tooltip>
    );
  }
  function displayFeatureNameWithLink() {
    return (
      <Link
        component={RouterLink}
        to={`/abac/${element.appId}/feature/${element.featureId}`}
        title={`View ${element.featureName} details`}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {element.featureName}
      </Link>
    );
  }

  return (
    <>
      <TableRow
        hover
        key={element.featureName}
        sx={classes.rowCell}
        onClick={() => customProps.openModal(element.featureId)}
      >
        {columns.map((column: ITableColumn) => (
          <TableCell key={`${element.featureName}:${column.propName}`} align="left" sx={classes.tableCell}>
            {column.propName === "" ? (
              <IconButton
                sx={{
                  border: "2px solid rgba(0,0,0,0.3)",
                }}
              >
                <AssignmentOutlined />
              </IconButton>
            ) : column.propName === "distribution" ? (
              displayDistribution()
            ) : column.propName === "featureName" ? (
              displayFeatureNameWithLink()
            ) : (
              element[column.propName]
            )}
          </TableCell>
        ))}
      </TableRow>
    </>
  );
}
